export const govCMSHome = process.env.REACT_APP_GOVCMS_HOME
export const PACTHome = process.env.REACT_APP_PACT_URL
export const SAMPLE_USER_PROFILE_ID = 'f6d539c8-14c7-4f20-8dc5-2d849f25cfz1'
export const ENQUIRIES_RESOLVE_DISPUTES_ISSUES_URL =
  govCMSHome +
  '/workplace-problems/fixing-a-workplace-problem/resolving-disputes-with-our-help'
export const ENQUIRIES_RESOLVE_WORKPLACE_ISSUES_URL =
  govCMSHome + '/workplace-problems/fixing-a-workplace-problem'
export const HOME_ACCESSIBILITY_URL =
  govCMSHome + '/website-information/using-fairwork-gov-au'
export const CALL_US_URL = govCMSHome + '/about-us/contact-us/call-us'
export const HOME_COPYRIGHT_URL =
  govCMSHome + '/website-information/copyright-statement'
export const HOME_DISCLAIMER_URL =
  govCMSHome + '/website-information/disclaimer'
export const HOME_FAST_FOOD_RESTURANTS_CAFES_URL =
  govCMSHome + '/find-help-for/fast-food-restaurants-cafes'
export const HOME_HORTICULTURE_URL = govCMSHome + '/horticulture-showcase'
export const HOME_INDEPENDANT_CONTRACTORS_URL =
  govCMSHome + '/find-help-for/independent-contractors'
export const HOME_LIBRARY_URL = govCMSHome + '/library'
export const HOME_PAYCALC_URL = PACTHome + '/findyouraward'
export const HOME_PRIVACY_URL = govCMSHome + '/website-information/privacy'
export const HOME_SUBSCRIPTION_PREF_URL =
  govCMSHome +
  '/website-information/staying-up-to-date/subscribe-to-email-updates'
export const HOME_USING_FAIRWORK_URL =
  govCMSHome + '/website-information/using-fairwork-gov-au'
export const HOME_SMALL_BUSINESS_URL = govCMSHome + '/small-business-showcase'
export const TERMS_AND_CONDITIONS =
  govCMSHome +
  '/website-information/terms-and-conditions/my-account-terms-and-conditions'
export const ENQUIRIES_STEP_BY_STEP_GUIDES_URL =
  govCMSHome +
  '/workplace-problems/fixing-a-workplace-problem#step-by-step-guides'
export const ENQUIRIES_CONFIRMATION_PRIVACY_URL =
  govCMSHome + '/website-information/privacy'
export const ENQUIRIES_ENFORCING_LEGISLATION_URL =
  govCMSHome + '/about-us/compliance-and-enforcement'
export const ENQUIRIES_ENFORCING_POLICY_URL =
  govCMSHome + '/about-us/compliance-and-enforcement'
export const ENQUIRIES_CUSTOMER_SERVICE_CHARTER_URL =
  govCMSHome + '/about-us/our-vision/our-commitment-to-you'
export const Compliance_Enforcement_Policy_PDF_URL =
  'https://www.fairwork.gov.au/sites/default/files/migration/725/compliance-and-enforcement-policy.pdf'
export const Compliance_Enforcement_Policy_WORD_URL =
  'https://www.fairwork.gov.au/sites/default/files/migration/725/compliance-and-enforcement-policy.docx'
export const FWO_COMPLIANCE_ENFORCEMENT_POLICY =
  govCMSHome + '/about-us/accountability/our-policies'
export const FWO_PROACTIVE_INVESTIGATIONS =
  govCMSHome + '/about-us/compliance-and-enforcement/proactive-investigations'
export const EMPLOYEES_GUIDE_TO_DIFFICULT_CONVERSATIONS_URL =
  govCMSHome + 'online-learning-centre'
export const AWARD_REGISTERED_AGREEMENT_URL = govCMSHome + '/taxonomy/term/407'
export const AWARD_FAIRWORK_COMMISSION_URL =
  'https://www.fwc.gov.au/awards-agreements/agreements'
export const AWARD_AGREEMENTS_URL =
  govCMSHome + '/employment-conditions/agreements'
export const AWARD_SUMMARY =
  govCMSHome + '/employment-conditions/awards/awards-summary'
export const AWARD_VIEWER = 'https://library.fairwork.gov.au/award/?krn='
export const FEEDBACK_AND_COMPLAINTS_POLICY_DOCX =
  'https://www.fairwork.gov.au/ArticleDocuments/725/feedback-and-complaints-policy.docx.aspx'
export const FEEDBACK_AND_COMPLAINTS_POLICY_PDF =
  'https://www.fairwork.gov.au/ArticleDocuments/725/feedback-and-complaints-policy.pdf.aspx'
export const INTERACTIVE_TEMPLATE_TERMINATION_LETTER_DOCX =
  'https://www.fairwork.gov.au/sites/default/files/migration/766/Termination-of-employment-letter-template.docx'
export const INTERACTIVE_TEMPLATE_TERMINATION_LETTER_PDF =
  'https://www.fairwork.gov.au/sites/default/files/migration/766/Termination-of-employment-letter-template.pdf'
export const INTERACTIVE_TEMPLATE_SUCCESSFUL_PROBATION_LETTER_DOCX =
  'https://www.fairwork.gov.au/sites/default/files/migration/766/Successful-probation-letter-template.doc'
export const INTERACTIVE_TEMPLATE_SUCCESSFUL_PROBATION_LETTER_PDF =
  'https://www.fairwork.gov.au/sites/default/files/migration/766/successful-probation-letter-template.pdf'
export const NO_MATCH_UNPAID_WORKPLACE_PROBLEM_URL =
  govCMSHome + '/workplace-problems/fixing-a-workplace-problem'
export const INTERACTIVE_TEMPLATE_MANAGING_PERFORMANCE =
  govCMSHome + 'tools-and-resources/online-learning-centre/managing-performance'

export const INTERACTIVE_TEMPLATE_PERFORMANCE_SYSTEM_CHECKLIST =
  'https://www.fairwork.gov.au/sites/default/files/migration/715/setting-up-a-performance-system-checklist.docx'

export const INTERACTIVE_TEMPLATE_PERFORMANCE_REVIEW_DISCUSSION_PLAN =
  'https://www.fairwork.gov.au/sites/default/files/migration/715/performance-review-discussion-plan.docx'

export const INTERACTIVE_TEMPLATE_MANAGING_EMPLOYEES =
  govCMSHome + 'tools-and-resources/online-learning-centre/managing-employees'

export const MANAGING_UNDERPERFORMANCE =
  govCMSHome +
  'tools-and-resources/best-practice-guides/managing-underperformance'

export const INTERACTIVE_TEMPLATE_FIRST_WARNING_LETTER_DOCX =
  'https://www.fairwork.gov.au/sites/default/files/migration/766/First-warning-letter-template.docx'
export const INTERACTIVE_TEMPLATE_FIRST_WARNING_LETTER_PDF =
  'https://www.fairwork.gov.au/sites/default/files/migration/766/First-warning-letter-template.pdf'

export const INTERACTIVE_TEMPLATE_FINAL_WARNING_LETTER_DOCX =
  'https://www.fairwork.gov.au/sites/default/files/migration/766/Final-warning-letter-template.docx'

export const INTERACTIVE_TEMPLATE_FINAL_WARNING_LETTER_PDF =
  'https://www.fairwork.gov.au/sites/default/files/migration/766/Final-warning-letter-template.pdf'

export const INTERACTIVE_TEMPLATE_STAFF_MEETING_RECORDS_TEMPLATE_DOCX =
  'https://www.fairwork.gov.au/sites/default/files/migration/766/Staff-meeting-record-template.doc'

export const INTERACTIVE_TEMPLATE_STAFF_MEETING_RECORDS_TEMPLATE_PDF =
  'https://www.fairwork.gov.au/sites/default/files/migration/766/staff-meeting-record-template.pdf'

export const WORKPLACE_BASIC_QUIZ_SURVEY_LINK =
  'https://fwo.au1.qualtrics.com/jfe/form/SV_0HuWydN9GemeCxf'

export const INTERACTIVE_TEMPLATE_REQUEST_FOR_RECORDS_PDF =
  'https://www.fairwork.gov.au/sites/default/files/2025-04/fg-an-employees-guide-to-fixing-workplace-problems.pdf'

export const INTERACTIVE_TEMPLATE_REQUEST_FOR_RECORDS_DOCX =
  'https://www.fairwork.gov.au/sites/default/files/2025-04/fg-an-employees-guide-to-fixing-workplace-problems.docx'

export const INTERACTIVE_TEMPLATE_PAY_CALCULATOR =
  govCMSHome + 'pay-and-wages/pay-calculator'

export const INTERACTIVE_TEMPLATEA_ANNUAL_LEAVE_NOTICE_PDF =
  'https://www.fairwork.gov.au/sites/default/files/2023-11/sts-notice-of-requirements-to-take-annual-leave-for-temporary-shutdown.pdf'

export const INTERACTIVE_TEMPLATEA_ANNUAL_LEAVE_NOTICE_DOCX =
  'https://www.fairwork.gov.au/sites/default/files/2023-11/sts-notice-of-requirements-to-take-annual-leave-for-temporary-shutdown.docx'
export const INTERACTIVE_TEMPLATEA_EXCESSIVE_ANNUAL_LEAVE_DOCX =
  'https://www.fairwork.gov.au/sites/default/files/migration/766/direction-to-take-excessive-annual-leave.docx'

export const INTERACTIVE_TEMPLATEA_EXCESSIVE_ANNUAL_LEAVE_PDF =
  'https://www.fairwork.gov.au/sites/default/files/migration/766/direction-to-take-excessive-annual-leave.pdf'

export const INTERACTIVE_TEMPLATE_TAKE_ANNUAL_LEAVE =
  govCMSHome + 'leave/annual-leave/directing-an-employee-to-take-annual-leave'

export const INTERACTIVE_TEMPLATE_AGREEMENT_ANNUAL_LEAVE_DOCX =
  'https://fairwork.gov.au/sites/default/files/migration/766/ageement-to-annual-leave-in-advance.docx'

export const INTERACTIVE_TEMPLATE_AGREEMENT_ANNUAL_LEAVE_PDF =
  'https://www.fairwork.gov.au/sites/default/files/migration/766/ageement-to-annual-leave-in-advance.pdf'

export const INTERACTIVE_TEMPLATE_PAYMENT_ANNUAL_LEAVE =
  govCMSHome + 'leave/annual-leave/payment-for-annual-leave'

export const INTERACTIVE_TEMPLATE_LEAVE_CALCULATOR =
  govCMSHome + 'leave/leave-calculator'
export const COMMON_PROBLEMS =
  govCMSHome + '/workplace-problems/common-workplace-problems'
export const FIXING_PROBLEMS =
  govCMSHome +
  '/workplace-problems/fixing-a-workplace-problem/taking-steps-to-fix-a-problem'
